const names: { [key: string]: string } = {
	admin: "Admin",
	mechanic: "Servicemonteur",
	expert: "Expert",
	resident: "Bewoner",
}

export default names
